import * as React from "react";
export function SvgSpacesMediumDs(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M18 7c0-1.7-2.7-3-6-3S6 5.3 6 7v11.4c0 1.4 2.7 2.6 6 2.6s6-1.2 6-2.6V7zm-6-2c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2zm0 15c-3.2 0-5-1.1-5-1.6V8.7c1.1.8 2.9 1.3 5 1.3s3.9-.5 5-1.3v9.7c0 .4-1.8 1.6-5 1.6z"
        fill="#676767"
      />
    </svg>
  );
}
